import { ArrowRight, Gift } from "lucide-react"
import { useEffect, useState } from "react"
import SimpleModal from "../../../../shared/SimpleModal"
import { IconButton } from "@material-ui/core"
import { Close } from "@material-ui/icons"
import confetti from "canvas-confetti"

export default function ChristmasPrizeModal({
    onClose = () => { },
    open = false,
    prize,
    loading = false,
}) {

    const [isRevealed, setIsRevealed] = useState(false);

    useEffect(() => {
        if (loading || !open || isRevealed) return;

        confetti({
            particleCount: 100,
            spread: 70,
            origin: { y: 0.6 },
            colors: ["#1e5a3c", "#c41e3a", "#d4a843"],
        })
    }, [loading, open])

    if (!open || !prize) return null

    return (
        <SimpleModal
            open={open}
            onClose={onClose}
            maxWidth="xs"
            style={{ borderRadius: 20 }}
            fullScreenOnMobile={false}
        >
            <div className="text-center font-['SF_Pro'] relative">
                {loading ? (
                    <div className="py-8">
                        <div className="relative mx-auto w-16 h-16 bg-gradient-to-br from-[#1e5a3c] to-[#145a32] rounded-[16px] animate-bounce flex items-center justify-center shadow-lg">
                            <Gift className="w-8 h-8 text-white" />
                        </div>
                        <p className="mt-4 text-[#5A5A5A]">Abrindo...</p>
                    </div>
                ) : (
                    <>
                        <div className="absolute -right-4 -top-4">
                            <IconButton
                                aria-label="close"
                                size='small'
                                onClick={onClose}
                            >
                                <Close />
                            </IconButton>
                        </div>
                        <div className="space-y-5 pt-1">


                            {/* Titulo */}
                            <div className="">
                                <h3
                                    className="text-lg font-semibold text-[#1a1a1a] mb-2"
                                    style={{ fontFamily: "var(--font-poppins), Poppins, sans-serif" }}
                                >
                                    Seu Escritório Digital acaba de ganhar um reforço!
                                </h3>
                                <p className="text-[#5A5A5A] text-sm leading-relaxed">
                                    A Facilita Jurídico separou um presente exclusivo para você continuar crescendo com mais agilidade e
                                    menos sobrecarga.
                                </p>
                            </div>

                            {/* Card do presente com icone fornecido */}
                            <div className="bg-[#f5f0e8] border border-[#e8e0d4] rounded-[20px] p-5">
                                <p className="text-xs text-[#5A5A5A] mb-4 font-medium">Seu presente:</p>
                                <div className="flex flex-col items-center gap-3">
                                    <div className="w-20 h-20 rounded-2xl overflow-hidden shadow-md flex justify-center items-center bg-slate-800">
                                        <div className="w-14 h-14 rounded-lg flex justify-center items-center" style={{ background: 'linear-gradient(45deg, #15e1e4, #0148f4)' }}>
                                            <Gift className="w-8 h-8 text-white" />
                                        </div>
                                    </div>
                                    <h4
                                        className="text-xl font-semibold text-[#1e5a3c]"
                                        style={{ fontFamily: "var(--font-poppins), Poppins, sans-serif" }}
                                    >
                                        {prize.label}
                                    </h4>
                                    <p className="text-[#5A5A5A] text-sm">{prize.subLabel || 'para usar quando quiser'}</p>
                                </div>
                            </div>

                            <div className="flex items-center justify-center gap-2 text-[#1e5a3c] bg-[#1e5a3c]/5 py-2 px-4 rounded-full">
                                <span className="text-base">🎁</span>
                                <p className="text-sm font-medium">O presente já está ativo na sua conta</p>
                            </div>

                            <button
                                onClick={onClose}
                                className="w-full bg-[#1e5a3c] hover:brightness-110 text-white font-medium py-5 rounded-[14px] shadow-md transition-all duration-300 flex items-center justify-center gap-2"
                            >
                                Continuar usando a plataforma
                                <ArrowRight className="w-4 h-4" />
                            </button>
                        </div>
                    </>
                )}
            </div>
        </SimpleModal>
    )
}